import { AcademyGridItemProps } from '../../../types/components/academy/indexPage/AcademyGridItem';
import Link from "next/link";
import { CoursesIcon, TutorialsIcon } from "../../../modules/Icons";
import { BlogSoftwareCategories } from "../../../staticData/Categories";

import { useState } from 'react';
import academyIndexHelpers from "../../../helpers/academyIndexHelpers";


const AcademyGridItem: React.FC<AcademyGridItemProps> = ({
  article,
}) => {
  const [isFocused, setIsFocused] = useState<boolean>();

  const { getFilterableSpecs } = academyIndexHelpers

  const deteremineAssetTypeIcon = (type: "Tutorial" | "Course"): React.ReactElement => {
    if (type === 'Tutorial') {
      return <TutorialsIcon className="fill-a-light-gray" />
    }
    if (type === "Course") {
      return <CoursesIcon className="fill-a-light-gray" />
    }
    return
  };

  const hasSoftwareSpec = !!getFilterableSpecs(article)?.Software.length

  return (
    <Link
      key={article.id}
      href={`/academy/${article.permalink}`}
      onMouseEnter={() => setIsFocused(true)}
      onMouseLeave={() => setIsFocused(false)}
      className="w-full flex-grow-0 flex-shrink-0 max-w-[540px] transition-transform duration-300 hover:scale-[102%] hover:shadow-lg"
    >
      <article className="bg-gray-900 rounded-[5px] max-w-[540px] overflow-hidden">
        <div className="w-full max-h-[253px] overflow-hidden">
          <div
            className="w-full h-[253px]  bg-center bg-cover bg-image"
            style={{ backgroundImage: `url(${article.thumbnail})` }}
          ></div>
        </div>

        <div className="px-5 pb-5 pt-3 max-h-[162px] flex flex-col gap-y-4">
          {hasSoftwareSpec && <div className="flex items-center h-[24px] mt-2 max-w-[540px]">
              {getFilterableSpecs(article)?.Software?.map((softwareName) => {
                const cat = BlogSoftwareCategories.find((c) => c.text === softwareName);
                return cat ? <div key={softwareName} className="!w-6">{cat.icon}</div> : null;
              })}
            </div>
          }
          <div
            cy-test-id="academy-index-grid-title"
            className={`inter text-[14px] leading-[24px] overflow-hidden h-[48px] ${isFocused ? 'text-[#00A1E0]' : ''
              }`}
          >
            {article?.title}
          </div>

          <div className="flex gap-6 text-[#7F898D] text-[8px] xl:text-[12px]">
            <div className="flex items-center gap-2">
              {deteremineAssetTypeIcon(article.asset_type as "Tutorial" | "Course")}{article.asset_type}
            </div>

          </div>
          </div>
      </article>
    </Link>
  );
};

export default AcademyGridItem;
